module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';

	global.jQuery = __webpack_require__(1);

	var commonModule = 'redi-common',
	    angular = __webpack_require__(2);

	__webpack_require__(3);
	__webpack_require__(4);
	__webpack_require__(5);
	__webpack_require__(6);

	var deps = [
	      'ngSanitize',
	      'ui.router',
	      'restangular',
	      'ui.bootstrap'
	    ];

	/**
	 * Main app module for redi-common
	 */
	angular.module(commonModule, deps);

	__webpack_require__(7)(angular, commonModule);
	__webpack_require__(14)(angular, commonModule);

	var logging = __webpack_require__(19);

	module.exports.logRepository = __webpack_require__(20);

	module.exports.initialize = function () {
	  logging.initialize();
	};

	module.exports.cleanup = function () {
	  logging.cleanup();
	};

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = require("jquery");

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = require("angular");

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = require("angular-sanitize");

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = require("angular-ui-bootstrap");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = require("angular-ui-router");

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	module.exports = require("restangular");

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = function(angular, moduleName) {
	  angular.module(moduleName)
	    .config(__webpack_require__(8))
	    .service('apiFactory', __webpack_require__(11))
	    .factory('httpHeadersOverrideService', __webpack_require__(12))
	    .service('rediWebAppConfigApi', __webpack_require__(13))
	    .constant('REDI_WEBAPP_CONFIG_PATH', '/redi-webapp-config.json');
	};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var logWindowIdService = __webpack_require__(9);

	module.exports = /*@ngInject*/ ["$httpProvider", function($httpProvider) {
	  logWindowIdService.onInitialized(function() {
	    $httpProvider.defaults.headers.common.windowId = logWindowIdService.getWindowId();
	  });
	}];


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var uuid = __webpack_require__(10),
	    windowId,
	    onInitializedCallbacks = [];

	function invokeOnInitializedCallbacks() {
	  onInitializedCallbacks.forEach(function(cb) {
	    cb();
	  });
	}

	function initialize() {
	  /* global fin:false */
	  if (typeof fin !== 'undefined') {
	    fin.desktop.main(function() {
	      windowId = fin.desktop.Window.getCurrent().name;
	      invokeOnInitializedCallbacks();
	    });
	  } else {
	    windowId = uuid.v4();
	    invokeOnInitializedCallbacks();
	  }
	}

	module.exports = {
	  onInitialized: function(cb) {
	    if (windowId) { // Already initialized, invoke immediately
	      setTimeout(cb);
	    } else {
	      onInitializedCallbacks.push(cb);
	    }
	  },
	  getWindowId: function() {
	    if (!windowId) {
	      console.log('Cannot retrieve windowId before OpenFin API is initialized, should only call this function after the onInitialized() is called.');
	    }
	    return windowId;
	  },
	  init: initialize,
	  // Only used during testing
	  reinitialize: function() {
	    windowId = null;
	    initialize();
	  }
	};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	module.exports = require("node-uuid");

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = /* @ngInject */ ["$location", "Restangular", "rediWebAppConfigApi", function ($location, Restangular, rediWebAppConfigApi) {
	  function getUrl(addressConfigName, baseUrl) {
	    return rediWebAppConfigApi.get().then(function (rediWebAppConfig) {
	      var url = '';
	      var configuredAddress = rediWebAppConfig[addressConfigName];
	      if (configuredAddress) {
	        url = $location.protocol() + '://' + configuredAddress;
	      }
	      url += baseUrl;
	      return url;
	    });
	  }

	  this.create = function (addressConfigName, baseUrl, configurator) {
	    return getUrl(addressConfigName, baseUrl).then(function (url) {
	      return Restangular.withConfig(function (RestangularConfigurer) {
	        RestangularConfigurer.setBaseUrl(url);
	        if (configurator) {
	          configurator(RestangularConfigurer);
	        }
	      });
	    });
	  };
	}];


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = /*@ngInject*/ ["$http", function ($http) {
	  return {
	    set: function (property, value) {
	      $http.defaults.headers.common[property] = value;
	    },
	    reset: function (property) {
	      delete $http.defaults.headers.common[property];
	    }
	  };
	}];


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	'use strict';

	RediWebAppConfigApi.$inject = ["$q", "$log", "$http", "REDI_WEBAPP_CONFIG_PATH"];
	function RediWebAppConfigApi($q, $log, $http, REDI_WEBAPP_CONFIG_PATH) {
	  var that = this;

	  var configPromise;

	  function getConfigOrEmptyObject() {
	    return $q(function (resolve) {
	      $http.get(REDI_WEBAPP_CONFIG_PATH)
	          .then(function (response) {
	            resolve(response.data);
	          }, function () {
	            resolve({});
	          });
	    });
	  }

	  that.get = function () {
	    if (!configPromise) {
	      configPromise = getConfigOrEmptyObject()
	          .then(function (config) {
	            $log.info('Using configuration: ' + JSON.stringify(config));
	            return config;
	          });
	    }
	    return configPromise;
	  };
	}

	module.exports = /* @ngInject */ RediWebAppConfigApi;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = function (angular, moduleName) {
	  angular.module(moduleName)
	      .service('decompressor', __webpack_require__(15))
	      .service('safeDigester', __webpack_require__(18));
	};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var pako = __webpack_require__(16);
	var Rx = __webpack_require__(17);

	module.exports = /* @ngInject */ function () {
	  var that = this;

	  that.decompressJsonBlobToObject = function (blob) {
	    return that.convertBlobToArrayBuffer(blob)
	        .map(that.decompress)
	        .map(that.decodeString)
	        .map(that.parseJson);
	  };

	  that.convertBlobToArrayBuffer = function (blob) {
	    return Rx.Observable.create(function (observer) {
	      var reader = new FileReader();
	      reader.onload = function () {
	        observer.onNext(this.result);
	        observer.onCompleted();
	      };
	      try {
	        reader.readAsArrayBuffer(blob);
	      } catch (e) {
	        console.log('Unable to convert blob to array buffer.');
	      }
	    });
	  };

	  that.decompress = function (compressed) {
	    return pako.inflate(compressed);
	  };

	  that.decodeString = function (arrayBuffer) {
	    return new TextDecoder('utf-8').decode(arrayBuffer);
	  };

	  that.parseJson = function (json) {
	    try {
	      return JSON.parse(json);
	    } catch (e) {
	      console.log('Expected JSON on websocket, received ' + json);
	    }
	  };
	};


/***/ }),
/* 16 */
/***/ (function(module, exports) {

	module.exports = require("pako");

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	module.exports = require("rx");

/***/ }),
/* 18 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = /* @ngInject */ ["$timeout", function ($timeout) {
	  this.digest = function (scope) {
	    $timeout(function () {
	      scope.$digest();
	    }, 0);
	  };
	}];


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var logRepository = __webpack_require__(20);
	var logListener = __webpack_require__(22);
	var logWindowIdService = __webpack_require__(9);

	var instance = null;

	module.exports = {
	  initialize: function () {

	    if (instance) {
	      return instance;
	    }

	    instance = this;

	    logListener.init();
	    logWindowIdService.init();

	    var initLogMessage = 'User activity logging initialized';
	    logRepository.log({
	      logString: initLogMessage
	    });
	    console.log(initLogMessage);

	    return instance;
	  },

	  cleanup: function () {
	    logListener.cleanup();
	  }
	};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _ = __webpack_require__(21),
	  logWindowIdService = __webpack_require__(9);

	function normalize(logItem) {
	  if (_.isString(logItem)) {
	    return {
	      logString: logItem
	    };
	  } else if (_.isObject(logItem)) {
	    return _.pick(logItem, [ 'logString', 'correlationId' ]);
	  }
	}

	function validate(logItem) {
	  if (!logItem.logString) {
	    throw new Error('Invalid attempt to send empty string to activity log.');
	  }
	}

	function getAuthorizationToken() {
	  try {
	    return JSON.parse(localStorage.authorizationToken).access_token;
	  } catch (e) {
	    console.log('Unable to retrieve user authorization token while logging user activity.');
	    return null;
	  }
	}

	function log(logItem) {
	  logItem = normalize(logItem);

	  validate(logItem);
	  var authorizationToken = getAuthorizationToken();
	  if (authorizationToken) {
	    logWindowIdService.onInitialized(function() {
	      window.fetch('/spread-trader/webapi/user-activity-logs', {
	        method: 'post',
	        headers: {
	          'Authorization': 'Bearer ' + authorizationToken,
	          'correlationId': logItem.correlationId,
	          'windowId': logWindowIdService.getWindowId()
	        },
	        body: logItem.logString
	      });
	    });
	  }

	}

	module.exports = {
	  log: log
	};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

	module.exports = require("lodash");

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var uuid = __webpack_require__(10),
	    logRepository = __webpack_require__(20),
	    body = window.document.body;

	function closestWithAttr(element, attr) {
	  var parent = element;

	  while (parent && parent !== body) {
	    if (parent.hasAttribute(attr)) {
	      return parent;
	    }
	    parent = parent.parentNode;
	  }
	}

	function logEvent(target, context, evtType, correlationId) {
	  var log = {
	    correlationId: correlationId,
	    logString: evtType + ': ' + target
	  };

	  if (context) {
	    log.logString += ', Context: ' + context;
	  }

	  logRepository.log(log);
	}

	function logListener(evtType, attrPrefix) {
	  return function(evt) {
	    var targetElement = closestWithAttr(evt.target, attrPrefix + 'log-target'),
	        contextElement = closestWithAttr(evt.target, attrPrefix + 'log-context'),
	        target, context;

	    if (!targetElement || evt.button !== 0 || targetElement.hasAttribute('disabled')) {
	      return;
	    }

	    target = targetElement.getAttribute(attrPrefix + 'log-target');
	    context = contextElement && contextElement.getAttribute(attrPrefix + 'log-context');

	    evt.correlationId = targetElement.getAttribute('log-correlation-id-override') || uuid.v4();
	    logEvent(target, context, evtType, evt.correlationId);
	  };
	}

	var clickListener = logListener('Click', /* no prefix - listen for clicks by default */''),
	    mousedownListener = logListener('Mousedown', 'mousedown-');

	function init() {
	  body.addEventListener('click', clickListener, true);
	  body.addEventListener('mousedown', mousedownListener, true);
	}

	function cleanup() {
	  body.removeEventListener('click', clickListener, true);
	  body.removeEventListener('mousedown', mousedownListener, true);
	}

	module.exports = {
	  init: init,
	  cleanup: cleanup
	};


/***/ })
/******/ ]);


//////////////////
// WEBPACK FOOTER
// /app/~/redi-common-angular/bin/common/js/redi-common.js
// module id = 13
// module chunks = 0